import React from 'react';
import { adminNavSections } from '@/admin/adminNavSections';
import { SideNavSection } from '../SideNavSection';

export const AdminSideNavSections = () =>
	adminNavSections.map((section, index) => (
		<SideNavSection key={section.title ?? index} title={section.title} items={section.items} />
	));
